import type { ProductCode } from '@meteoradar/shared/enums/product-code';
import { product, products } from '../state/store.js';

type Props = {
  onSelect: (code: ProductCode) => void;
};

export const ProductSelector = ({ onSelect }: Props) => (
  <label class="field">
    <span class="field__label">Producto</span>
    <select
      class="field__select"
      value={product.value}
      onChange={event => onSelect(event.currentTarget.value as ProductCode)}
    >
      {products.value.map(item => (
        <option key={item.code} value={item.code}>{item.code} · {item.name}</option>
      ))}
    </select>
  </label>
);
